// Import analytics first to ensure as much as possible is instrumented.
import './instrument';

// Import core-js polyfills next to ensure they're available for all code.
import 'core-js/modules/es.array.at';
import 'core-js/modules/es.array.to-sorted';
import 'core-js/modules/es.array.to-reversed';
import 'core-js/modules/es.array.to-spliced';
import 'core-js/modules/es.array.with';

// Import the router entrypoint last.
import 'expo-router/entry';
